<div class="min-h-screen bg-slate-50 flex justify-center sm:pb-20">
  <div
    class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-3xl sm:shadow-2xl sm:border border-slate-200 overflow-hidden relative flex flex-col">
    <!-- Header -->
    <div class="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-slate-100 shadow-sm">
      <div class="flex items-center gap-4 px-5 py-4">
        <!-- Back button typically injected by parent, leaving space if needed -->
        <!-- <button class="h-10 w-10 grid place-items-center rounded-2xl hover:bg-slate-50 border border-transparent hover:border-slate-100 hover:shadow-sm active:scale-95 transition-all text-slate-700" (click)="toBack()">
          <span class="material-symbols-outlined">arrow_back</span>
        </button> -->
        <div class="flex-1">
          <h1 class="text-xl font-black text-slate-800 tracking-tight">{{ 'เลือกแขกและห้องพัก' | translate : 'select-guest-room' }}</h1>
          <p class="text-xs font-medium text-slate-500 mt-0.5">{{ 'ระบุจำนวนผู้เข้าพักและจำนวนห้อง' | translate : 'select-guest-room' }}</p>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto w-full p-5 space-y-4 pb-28">
      @for(item of listItems; track $index){
      <div
        class="flex items-center justify-between gap-4 p-4 rounded-3xl border border-slate-100 bg-white shadow-sm hover:border-blue-200 transition-colors group">
        <div class="flex items-center gap-4">
          <div
            class="w-12 h-12 rounded-2xl bg-blue-50 flex items-center justify-center shrink-0 border border-blue-100 group-hover:bg-blue-500 transition-colors">
            <span class="material-symbols-outlined text-blue-500 group-hover:text-white transition-colors"
              style="font-size:1.5rem">
              {{ item.status === 'rooom' ? 'meeting_room' : (item.name.includes('เด็ก') ? 'child_care' : 'person') }}
            </span>
          </div>
          <div>
            <div class="text-[15px] font-bold text-slate-800">{{ item.name | translate : 'select-guest-room' }}</div>
            @if(item.status !='rooom') {
            <!-- <div class="text-[11px] font-medium text-slate-400 mt-0.5">{{item.content}}</div> -->
            }
          </div>
        </div>

        <!-- Stepper -->
        <div
          class="flex items-center justify-between gap-2 w-[110px] bg-slate-50 rounded-2xl border border-slate-200 p-1.5 shadow-inner">
          <button
            class="w-8 h-8 flex items-center justify-center rounded-xl bg-white shadow-sm hover:shadow active:scale-95 text-slate-500 hover:text-blue-600 transition-all border border-slate-100 disabled:opacity-50"
            (click)="remove(item)">
            <span class="text-xl font-medium leading-none mb-0.5">−</span>
          </button>

          <div class="w-8 text-center text-[15px] font-bold text-slate-800">{{item.amount}}</div>

          <button
            class="w-8 h-8 flex items-center justify-center rounded-xl bg-white shadow-sm hover:shadow active:scale-95 text-slate-500 hover:text-blue-600 transition-all border border-slate-100"
            (click)="add(item)">
            <span class="text-xl font-medium leading-none mb-0.5">+</span>
          </button>
        </div>
      </div>
      }
    </div>

    <!-- Bottom Button -->
    <div class="absolute bottom-0 inset-x-0 bg-white/80 backdrop-blur-md border-t border-slate-100 p-5 z-20">
      <button class="w-full rounded-2xl py-3.5 text-sm font-bold text-white transition-all shadow-md shadow-blue-300"
        [ngClass]="totalRoomAmount() == 0 || totalGuestAmount() == 0 ? 'cursor-not-allowed bg-slate-300 shadow-none' : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 active:scale-[0.98]'"
        (click)="totalRoomAmount() > 0 && totalGuestAmount() > 0 && submit()">
        <span class="flex items-center justify-center gap-2">
          @if(totalGuestAmount() == 0){
          {{ 'ใส่แขกที่เข้าพัก' | translate : 'select-guest-room' }}
          } @else if(totalRoomAmount() == 0){
          {{ 'ใส่จำนวนห้อง' | translate : 'select-guest-room' }}
          } @else {
          {{ 'อัปเดตแขกและห้องพัก' | translate : 'select-guest-room' }}
          <span class="material-symbols-outlined" style="font-size:1rem">check_circle</span>
          }
        </span>
      </button>
    </div>
  </div>
</div>